import { useFormikContext } from 'formik';
import { FormikTextField } from '../../../../components/form-components/common-components/text-field/FormikTextField';
import { FormikDropdown } from '../../../../components/form-components/common-components/dropdown/FormikDropdown';
import { userFieldIcons as UI } from './userFieldIcons';
import styles from './UserForm.module.css';

export type UserEditFormValues = {
  username: string;
  email: string;
  role: string;
  isActive: boolean;
};

type UserEditFormFieldsProps = {
  roleOptions: Array<{ value: string; label: string }>;
};

const UserEditFormFields = ({ roleOptions }: UserEditFormFieldsProps) => {
  const { values, setFieldValue } = useFormikContext<UserEditFormValues>();

  return (
    <>
      <div className={styles.inputContainer}>
        <FormikTextField
          name="username"
          label="Kullanıcı Adı"
          placeholder="Kullanıcı adı"
          startIcon={UI.userName}
          disabled
        />
      </div>

      <div className={styles.inputContainer}>
        <FormikTextField
          name="email"
          label="E-posta"
          placeholder="E-posta"
          startIcon={UI.email}
          disabled
        />
      </div>

      <div className={styles.inputContainer}>
        <FormikDropdown
          name="role"
          label="Rol"
          placeholder="Rol seçiniz"
          options={roleOptions}
          startIcon={UI.role}
        />
      </div>

      <div className={styles.inputContainer}>
        <label className={styles.activeToggle}>
          <input
            type="checkbox"
            checked={values.isActive}
            onChange={e => setFieldValue('isActive', e.target.checked)}
            className={styles.checkbox}
          />
          <span className={styles.activeToggleContent}>
            <span className={styles.activeToggleLabel}>Hesap Durumu</span>
            <span className={styles.activeToggleHint}>
              {values.isActive ? 'Kullanıcı aktif' : 'Kullanıcı pasif'}
            </span>
          </span>
        </label>
      </div>
    </>
  );
};

export default UserEditFormFields;
